import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { communityFeedApi } from 'src/Services/API';
import { editCommunityFeedItemCommentsCache } from 'src/Services/API/cache';
import { CreateCommentDto, CommentDto } from 'src/Services/API/generated';

export type EditCommunityFeedItemCommentVariables = {
  feedItemId: string;
  commentId: string;
} & CreateCommentDto;

export const useEditCommunityFeedItemComment = (
  options?: UseMutationOptions<CommentDto, unknown, EditCommunityFeedItemCommentVariables>
) => {
  const queryClient = useQueryClient();

  return useMutation<CommentDto, unknown, EditCommunityFeedItemCommentVariables>(
    'edit-community-feed-item-comment',
    async (variables: EditCommunityFeedItemCommentVariables) => {
      const response = await communityFeedApi.communityFeedControllerEditComment(
        variables.feedItemId,
        variables.commentId,
        variables
      );

      return response.data;
    },
    {
      ...options,
      onSuccess(data, variables, context) {
        // Edit the comment from comments list query
        editCommunityFeedItemCommentsCache(queryClient, variables.feedItemId, original =>
          original.id === variables.commentId ? data : original
        );

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
